<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('shopee.account.label')" :columns="6" :required="true" v-if="shopeeAccounts.length">
        <select v-model="filters.account.identifier" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="account in shopeeAccounts" :value="account.shopId">{{ `${account.shopName} (${account.shopId})` }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import Loader from '@/components/template/Loader'
import FormGroup from '@/components/template/FormGroup'

export default {
  data: () => ({
    loading: false,
    filters: {
      account: {
        identifier: null
      }
    }
  }),
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (!this.shopeeAccounts.length) {
      this.loading = true
      this.fetchAccounts({
        options: {
          active: true
        }
      }).then(() => {
        this.loading = false
      })
    }
  },
  methods: {
    ...mapActions('shopeeAccounts', [
      'fetchAccounts'
    ])
  },
  computed: {
    ...mapFields({
      shopeeAccounts: 'shopeeAccounts.accounts'
    })
  },
  components: {
    FormGroup,
    Loader
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Shopee.vue?aa392a98